import React, { Component } from 'react'
import { Box, Alert } from '@mui/material'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'

import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class ConfirmDeleteDialog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            submitting: false,
        }

        this.deleteItem = this.deleteItem.bind(this)
    }

    deleteItem() {
        if (!this.props.url) {
            return
        }

        this.setState({ submitting: true })
        this.props.kedo
            .api()
            .delete(this.props.url)
            .then((response) => {
                if (this.props.onSuccess) {
                    this.props.onSuccess()
                } else {
                    this.props.onClose()
                }
            })
            .catch(
                (error) =>
                    console.log('Error deleting item', error) ||
                    this.setState({
                        error: true,
                        submitting: false,
                    })
            )
    }

    generateDialogFooter() {
        return (
            <>
                {this.state.error && this.props.errorLabel ? (
                    <StyledButton
                        onClick={() => this.props.onClose()}
                        color="secondary"
                    >
                        {this.props.kedo.t('Close')}
                    </StyledButton>
                ) : null}
                {!this.state.error ? (
                    <div>
                        <StyledButton onClick={this.deleteItem} color="error">
                            {this.state.submitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faTrashAlt} />
                            )}
                            &nbsp; {this.props.kedo.t('Delete')}
                        </StyledButton>{' '}
                        &nbsp;
                        <StyledButton
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </div>
                ) : null}
            </>
        )
    }

    render() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                fullWidth
                title={this.props.kedo.t('Confirmation')}
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true }}
                actions={this.generateDialogFooter()}
            >
                <Box component="form">
                    {!this.state.error &&
                        (() => {
                            const itemLabel =
                                (typeof this.props.itemName === 'string' &&
                                    this.props.itemName.trim()) ||
                                null
                            const translationKey = itemLabel
                                ? 'confirm_delete_text_permanent'
                                : 'confirm_delete_text_singular'

                            return this.props.kedo.t(translationKey, {
                                item:
                                    itemLabel ||
                                    this.props.kedo.t('Dossier'),
                            })
                        })()}
                    {this.props.warning ? <br /> : null}
                    {this.props.warning ? (
                        <Alert severity={'warning'}>{this.props.warning}</Alert>
                    ) : null}
                    {this.state.error && this.props.errorLabel ? (
                        <Alert severity={'error'}>
                            &nbsp; {this.props.errorLabel}
                        </Alert>
                    ) : null}
                </Box>
            </AppDialog>
        )
    }
}

export default ConfirmDeleteDialog
